import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setMessage } from '../../../redux/slice';

import * as api from '../api';

export const doGetRoutePlans = createAsyncThunk('routePlans/doGetRoutePlans', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getRoutePlans(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetRoutePlan = createAsyncThunk('routePlans/doGetRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doOptimizeRoutePlan = createAsyncThunk('routePlans/doOptimizeRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.optimizeRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateRoutePlan = createAsyncThunk('routePlans/doCreateRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.createRoutePlan(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateRoutePlan = createAsyncThunk('routePlans/doUpdateRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.updateRoutePlan(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteRoutePlan = createAsyncThunk('routePlans/doDeleteRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.deleteRoutePlan(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doReorderRoutePlan = createAsyncThunk('routePlans/doReorderRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.reorderRoutePlan(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDispatchRoutePlan = createAsyncThunk('routePlans/doDispatchRoutePlan', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.dispatchRoutePlan(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doLockRiderInsideRoutePlan = createAsyncThunk(
  'routePlans/doLockRiderInsideRoutePlan',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.lockRiderInsideRoutePlan(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doRemoveRidersInsideRoutePlan = createAsyncThunk(
  'routePlans/doRemoveRidersInsideRoutePlan',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.removeRidersInsideRoutePlan(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doRemoveOrdersInsideRoutePlan = createAsyncThunk(
  'routePlans/doRemoveOrdersInsideRoutePlan',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.removeOrdersInsideRoutePlan(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
export const doAddOrdersToRoutePlan = createAsyncThunk('routePlans/doAddOrdersToRoutePlan', async (data, thunkAPI) => {
  try {
    const { response, error } = await api.addOrdersToRoutePlan(data);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doSwapOrdersToRiderRoutePlan = createAsyncThunk(
  'routePlans/doSwapOrdersToRiderRoutePlan',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.swapOrdersToRiderRoutePlan(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
